import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import type { Tone } from "src/admin/exonn-common/format.ts";

/** Плашка статуса: тон отдельно от акцентного цвета страницы. */
export const StatusPill = ({ tone, label }: { tone: Tone; label: string }) => (
  <span css={(theme: ExactTheme) => pill(theme, tone)}>{label}</span>
);

const pill = (theme: ExactTheme, tone: Tone) => {
  const { fg, bg, border } = colors(theme)[tone];

  return css`
    display: inline-block;
    white-space: nowrap;
    border-radius: 999px;
    padding: 1px 9px;
    font-size: 12px;
    line-height: 18px;
    color: ${fg};
    background: ${bg};
    border: 1px solid ${border};
  `;
};

const colors = ({ colorsV2: c }: ExactTheme) => ({
  success: { fg: c.green[700], bg: c.green[25], border: c.green[200] },
  info: { fg: c.blue[700], bg: c.blue[25], border: c.blue[200] },
  warning: { fg: c.orange[800], bg: c.orange[25], border: c.orange[200] },
  error: { fg: c.red[700], bg: c.red[25], border: c.red[200] },
  // grey[600] на светлом фоне — 3,8:1, ниже AA для 12px.
  grey: { fg: c.grey[800], bg: c.grey[25], border: c.grey[200] },
});
